import { Outlet, useLocation } from "react-router-dom";

import { usePermissions } from "@/lib/permissions";
import { AccessDeniedPage } from "@/pages/AccessDeniedPage";

/**
 * Guards routes based on permissions.
 *
 * Checks if the user has permission to access the current route.
 * Shows AccessDeniedPage if not authorized.
 *
 * Use this inside ProtectedRoute to add permission-based access control.
 */
export function PermissionGuard() {
  const location = useLocation();
  const { canAccessRoute, isLoading } = usePermissions();

  // Don't block while permissions are loading
  if (isLoading) {
    return <Outlet />;
  }

  // Check if user can access the current route
  if (!canAccessRoute(location.pathname)) {
    return <AccessDeniedPage />;
  }

  return <Outlet />;
}
